function geoFindMe() {
  var output = document.getElementById("address");
  if (!navigator.geolocation) {
    window.alert("Geolocation is not supported by your browser");
    return;
  }
  function success(position) {
    var latitude = position.coords.latitude;
    var longitude = position.coords.longitude;
    var coordinates = latitude + ', ' + longitude;
    output.value = coordinates;
    $(document.forms["locSearchboxForm"]).trigger('submit');
  }
  function error() {
    window.alert("Unable to retrieve your location. Have you disabled the location setting? Enable this setting and try again.");
  }
  navigator.geolocation.getCurrentPosition(success, error);
}

function Locations(options) {
  var self = this;
  var defaults = {
    template: '#location-result__template',
    results: '.js-locations-results',
    form: '.js-locations-form',
    online: '.js-locations-filter--online',
    ufc: '.js-locations-filter--ufc',
    result: '.js-location-result',
    name: '.js-location-name',
    search: '#address',
    favButton: '.js-favorite-button',
    mapContainer: 'map',
    center: {
      lat: 37.2570174,
      lng: -98.6704359
    },
    zoom: 5,
    app_id: null,
    app_code: null,
  }

  this.settings = $.extend({}, defaults, options);
  this.map = {};

  this.markers = {};
  this.group = {};
  var smallMarker = null;
  var largeMarker = null;
  var onLoadQuery = null;
  var layout = $(this.settings.results).data('layout');

  if (this.settings.app_code == null || this.settings.app_id == null) {
    console.error('Cannot find APP_ID or APP_CODE. Please confirm settings are correct.');
    return false;
  }

  init.call(this);

  function addMarker(location) {
    if (layout == 'list') {
      return;
    }
    var coords = {
      lat: location.latitude,
      lng: location.longitude
    };
    var marker = new H.map.Marker(
      coords,
      {
        icon: smallMarker
      }
    );

    this.group.addObject(marker);

    this.markers[location.id] = marker;

    marker.addEventListener('tap', function (e) {
      toggleMarker.call(self, location.id);
      toggleLocation.call(self, location.id);
    });
  };

  function events() {
    var settings = this.settings;
    $(settings.form).submit(function (e) {
      e.preventDefault();

      var address = $(settings.search).val();
      var online_ordering = $(settings.online).is(':checked');
      var has_ufc = $(settings.ufc).is(':checked');
      var current_location = window.location.search.indexOf('current_location') !== -1;
      var currentLocation = window.location.search.indexOf('currentLocation') !== -1;

      //When our first form submission occurs, add utm params to local storage so that we can read it back when
      //user toggles has_ufc or online_ordering

      if (address == '' && !onLoadQuery) {
        return;
      }

      if (current_location || currentLocation) {
        window.App.myLocation.update(null, function () {
          address = window._currentLocation.zip;
          fetchLocations.call(self, address, online_ordering, has_ufc);
        })
      } else {
        fetchLocations.call(self, address, online_ordering, has_ufc);
      };

      ga('send', 'pageview', '/locations/?address=' + address);
    });

    $(settings.online).change(function () {
      $(settings.form).submit();
    });

    $(settings.ufc).change(function () {
      $(settings.form).submit();
    });

    $(settings.results).on('click', settings.name, function () {
      var id = $(this).parents(settings.result).data('id');

      if (layout !== 'list') {
        toggleMarker.call(self, id);
        toggleLocation.call(self, id);
      }
    });

    $(settings.results).on('click', settings.favButton, function (e) {
      e.preventDefault();
      var id = $(this).parents(settings.result).data('id');
      window.App.myLocation.update(id);

      $(settings.favButton).removeClass('is-active').text('Make Favorite');
      $(this).addClass('is-active').text('Favorite');
    });

    $(window).on('resize', window.App.utility.debounce(function () {
      if (layout !== 'list') {
        self.map.getViewPort().resize();
      } else {
        updateMapImages.call(self);
      }
    }, 500));
  };

  function updateMapImages() {
    var $resultItems = $(this.settings.result);

    $resultItems.each(function (index, result) {
      var $map = $(result).find('.js-result-map').first();
      var url = $map.data('bg');
      var minSize = $map.data('min-size');
      if (window.innerWidth > minSize) {
        $map.css('background-image', 'url(' + url + ')');
      }
    })
  }

  function fetchLocations(address, online_ordering, has_ufc) {
    var self = this;
    var map = this.map;

    // Add searching message
    outputMessage.call(this, {
      heading: 'Searching...',
      text: 'We\'re looking for all the locations near this address',
    });

    if (layout !== 'list') {
      self.group.removeAll();
    }
    self.markers = {};

    // clear query
    var query = '';

    console.log('here is the utm', document.getElementById('utm').value)
    // set up query to send to Hooters Locations API
    if (!address && utm) {
      geoFindMe();
      return;
    }
    if (!address && onLoadQuery) {
      query = '/api/search_locations.json' + onLoadQuery;
      onLoadQuery = null;
      console.log('case 1')
    } else {
      var api = '/api/search_locations.json';
      var search = '?address=' + address;
      console.log('case 2')
      if (online_ordering) {
        search += '&online_ordering=' + online_ordering;
      }

      if (has_ufc) {
        search += '&has_ufc=' + has_ufc;
      }
      query = api + search;
      if (localStorage.utmParams) {
        search = search + localStorage.utmParams
      }
      window.history.replaceState(null, null, search);
      $(self.settings.search).val(address);
    }

    // Get locations from Hooters Locations API
    $.getJSON(query, function (data) {
      // Empty locations list
      $(self.settings.results).empty();
      if (!data.locations || !data.locations.length) {
        outputMessage.call(self, {
          heading: 'No Hooters Found',
          text: 'Try entering another City, State or Zipcode'
        })
        if (data.geocode && data.geocode.latitude && data.geocode.longitude) {
          var latitude = data.geocode.latitude;
          var longitude = data.geocode.longitude;
          map.setCenter({ lat: latitude, lng: longitude });
          map.setZoom(10);
        }
        return;
      }

      // add each location to the map and a result to the results list
      for (var i in data.locations) {

        var currentLocationData = data.locations[i]
        currentLocationData.list = (layout == 'list');
        $(self.settings.results).append(html.bind(self, currentLocationData));
        addMarker.call(self, data.locations[i]);
      }

      // set up static map images
      updateMapImages.call(self);

      // reattach external link handler
      window.App.externalPopup.init();

      // set up conditional variables
      var isSearchingCurrentLocation = window.location.search.indexOf('currentLocation=') !== -1;
      var isSearchingAddress = window.location.search.indexOf('address=') !== -1;

      if (layout !== 'list') {
        if (isSearchingCurrentLocation && window._currentLocation) {
          var latitude = window._currentLocation.latitude;
          var longitude = window._currentLocation.longitude;

          map.setCenter({ lat: latitude, lng: longitude });
          map.setZoom(10);
        } else if (isSearchingAddress) {
          var latitude = data.geocode.latitude;
          var longitude = data.geocode.longitude;
          map.setCenter({ lat: latitude, lng: longitude });
          map.setZoom(10);
        } else {
          $.each(self.markers, function (marker) { self.group.addObject(self.markers[marker]); });
          map.setViewBounds(self.group.getBounds());
        }
      }
    }).fail(function () {
      // display an graceful error if anything in the request failed
      outputMessage.call(self, {
        heading: 'Oops!',
        text: 'We\'re having trouble displaying results right now. Please try another search or check back again later.'
      });
    });
  };

  function outputMessage(options) {
    var defaults = {
      heading: 'No Hooters Found',
      text: 'Try entering another City, State or Zipcode'
    };

    var settings = $.extend({}, defaults, options);

    var html = [
      '<div class="c-locations-picker-message">',
      '<h1 class="c-locations-picker-message__title">' + settings.heading + '</h1>',
      '<p class="c-locations-picker-message__text">' + settings.text + '</p>',
      '</div>'
    ];

    var message = $(html.join(''));
    $(this.settings.results).empty().append(message);
  }

  function html(location) {
    var source = $(this.settings.template).first().html();
    var template = Handlebars.compile(source);
    return template(location);
  }

  function toggleMarker(id) {
    if (layout == 'list') {
      return;
    }
    var marker = this.markers[id];

    for (var i in this.markers) {
      this.markers[i].setIcon(smallMarker);
    }

    marker.setIcon(largeMarker);
  };

  function toggleLocation(id) {
    var location = $(this.settings.result + '[data-id="' + id + '"]');

    location.addClass('is-active')
      .siblings(this.settings.result)
      .removeClass('is-active');

    $(this.settings.results).animate({
      scrollTop: location[0].offsetTop - 50
    }, 200);
  };

  function init() {

    var queryParams = window.location.search.split('&')
    if (queryParams) {
      var source = (queryParams[0] && queryParams[0].includes('utm_source')) ? queryParams[0] : '';
      var medium = (queryParams[1] && queryParams[1].includes('utm_medium')) ? queryParams[1] : '';
      var campaign = (queryParams[2] && queryParams[2].includes('utm_campaign')) ? queryParams[2].replace('?', '') : '';

      let utm = `&${source}&${medium}&${campaign}`
      document.getElementById('utm').value = utm
      if (!localStorage.utmParams || localStorage.utmParams != utm) {
        localStorage.utmParams = utm
      } else {
        localStorage.removeItem('utmParams')
      }
    }

    if (layout !== 'list') {
      platform = new H.service.Platform({
        'app_id': this.settings.app_id,
        'app_code': this.settings.app_code,
        useHTTPS: true,
      });
      defaultLayers = platform.createDefaultLayers();
      this.map = new H.Map(
        document.getElementById(this.settings.mapContainer),
        defaultLayers.normal.map,
        {
          center: this.settings.center,
          zoom: this.settings.zoom,
        }
      );

      largeMarker = new H.map.Icon('/assets/images/marker.png', { size: { w: 59, h: 70 } });
      smallMarker = new H.map.Icon('/assets/images/marker-sm.png', { size: { w: 37, h: 43 } });

      this.group = new H.map.Group();
      this.map.addObject(this.group);

      var behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));

      // Get numbers for bitmask argument
      var DRAGGING = H.mapevents.Behavior.DRAGGING;
      var WHEELZOOM = H.mapevents.Behavior.WHEELZOOM;
      var DBLTAPZOOM = H.mapevents.Behavior.DBLTAPZOOM;

      // Disable all map interactivity.
      behavior.disable(DRAGGING + WHEELZOOM + DBLTAPZOOM);
    }

    events.call(this);
    updateMapImages.call(this);

    // if the search field is not empty, or there is a location set in the URL
    if ($(this.settings.search).val() != '' || window.location.search) {
      var $locationForm = $(this.settings.form).first();
      if (window.location.search) {
        onLoadQuery = window.location.search;
      }
      $locationForm.trigger('submit');
    } else {
      geoFindMe();
    }
  };

  return {
    map: self.map,
  }
}
